<template>
  <div>
    <template
      v-if="
        !isBookshelfBookLoading &&
        getCurrentBookshelfBooks &&
        getCurrentBookshelfBooks.length
      "
    >
      <ul class="item_list">
        <BaseShelfBook
          v-for="(book, index) in getCurrentBookshelfBooks"
          :key="index"
          :book="book"
          :library="true"
          @open-delete-modal="showDeleteConfirmation"
        />
      </ul>
      <!-- Pagination START -->
      <Pagination
        :current-page="currentPage"
        :total-count="getBookshelfTotalBookCount"
        :item-per-page="booksPerPage"
        @paginate="paginate"
      />
      <!-- Pagination END -->
    </template>
    <!-- ########### EMPTY LIBRARY ############ -->
    <template
      v-if="
        !isBookshelfBookLoading &&
        getCurrentBookshelfBooks &&
        !getCurrentBookshelfBooks.length &&
        !staticInput
      "
    >
      <div class="library_alert p_empty">
        <div class="stage_msg">
          <div class="not_found_img"></div>
          <p class="cell">
            <span class="tit pb-1">등록된 교재가 없습니다.</span>
            <br />
            <!-- <span class="sub">지금 바로 스토어에서 교재를 구매해 보세요.</span> -->
          </p>
          <div class="btn_wrap">
            <div class="box_btn" @click="showAllBooks">
              <!-- <span class="an_t">교재 구매</span> -->
              <span class="an_t">
                책 추가하기
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- ########### EMPTY LIBRARY END ############ -->
    <!-- ########### SEARCH LIBRARY NONE ############ -->
    <template
      v-if="
        !isBookshelfBookLoading &&
        getCurrentBookshelfBooks &&
        !getCurrentBookshelfBooks.length &&
        staticInput
      "
    >
      <div class="library_alert p_empty">
        <div class="stage_msg">
          <i>
            <img src="@/assets/images/view.png" alt="돋보기" />
          </i>
          <p class="cell">
            <span class="tit pb-1 none_result">
              '{{ result }}'에 대한 검색 결과가 없습니다.
            </span>
            <span class="sub clr" @click="totalShelf(getCurrentBookshelf.id)">
              뒤로가기
            </span>
          </p>
        </div>
      </div>
    </template>
    <!-- ########### SEARCH LIBRARY NONE END ############ -->
    <template>
      <transition name="modal-fade">
        <Modal v-if="showDeleteModal" @close="close">
          <div class="ly_pop_content ly_pop_msg ly_txt card relative">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="close">
                <span>{{ $t('library.deletemodal.close') }}</span>
              </a>
            </div>
            <div class="ly_inner ly_txt">
              <p class="tac">책장에서 삭제<br /></p>
              <div class="warningText">
                현재 책장에 복사된 책이 삭제됩니다. <br />
                (원본 도서는 전체 책장에서 확인이 가능합니다.)
              </div>

              <div class="button_wrap">
                <button type="submit" class="box_btn dull" @click="close">
                  취소
                </button>
                <button
                  type="submit"
                  class="box_btn"
                  @click="deleteBookshelf()"
                >
                  확인
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import {
  BOOKSHELF_BOOK_GET_LIST,
  BOOKSHELF_SET_CURRENT,
  UI_ENABLE_MOVE_BOOK_MODE,
  BOOKSHELF_BOOK_DELETE_BOOKS
} from '@/store/types'
import BaseShelfBook from '@/components/base/BaseShelfBook'

export default {
  name: 'BookTable',
  props: {
    staticInput: {
      type: String,
      required: true
    },
    activeFilters: {
      type: Array,
      default: () => []
    },
    isAddingBooks: {
      type: Boolean,
      default: false
    }
  },
  component: {
    BaseShelfBook
  },
  data() {
    return {
      currentPage: 1,
      booksPerPage: 30,
      sort: 'PD', //RD
      showDeleteModal: false,
      bookToDelete: null
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelfBooks',
      'isBookshelfBookLoading',
      'getBookshelfTotalBookCount',
      'getCurrentBookshelf',
      'getBookshelves'
    ]),
    result() {
      return this.staticInput || ''
    },
    allBookFilter() {
      return this.getBookshelves.filter((book) => book.bookshelfTp === 'DBS')
    }
  },
  watch: {
    staticInput() {
      this.currentPage = 1
    },
    sort() {
      this.currentPage = 1
    },
    activeFilters: {
      handler() {
        this.currentPage = 1
      },
      deep: true
    }
  },
  methods: {
    showDeleteConfirmation(book) {
      this.bookToDelete = book
      this.showDeleteModal = true
    },
    close() {
      this.showDeleteModal = false
      this.bookToDelete = null
    },
    async deleteBookshelf() {
      if (this.bookToDelete) {
        await this.$store.dispatch(BOOKSHELF_BOOK_DELETE_BOOKS, {
          bookshelfId: this.bookToDelete.bookshelfId,
          bookCode: this.bookToDelete.bookCd
        })
        // 책갯수 갱신
        this.$root.$emit('bookshelf-counts-updated')
        // 책리스트 갱신
        this.$emit('default-books')
        this.close()
      }
    },
    async paginate(page, sort = this.sort) {
      this.currentPage = page
      this.sort = sort

      // 책 추가 모드인지 확인하고 적절한 bookshelfId 설정
      const bookshelfId = this.isAddingBooks
        ? this.allBookFilter[0].id
        : this.getCurrentBookshelf
        ? this.getCurrentBookshelf.id
        : ''
      // API 호출
      await this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, {
        page,
        sort,
        bookshelfId,
        searchTxt: this.staticInput,
        filterList: this.activeFilters
      })
    },
    async totalShelf(id) {
      if (this.isAddingBooks) {
        await this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, {
          bookshelfId: this.allBookFilter[0].id || '',
          searchTxt: this.selfbook
        })
        this.$emit('reset-search')
        this.$emit('bookshelfChanged')
      } else {
        this.$store.commit(BOOKSHELF_SET_CURRENT, id)
        this.$emit('reset-search')
        this.$emit('bookshelfChanged')
      }
    },
    showAllBooks() {
      this.$store.commit(UI_ENABLE_MOVE_BOOK_MODE)
      this.$emit('show-all-books')
    }
  }
}
</script>
<style src="@/assets/css/page_library.css"></style>
<style lang="scss" scoped>
.none_result {
  display: block;
  & + .sub {
    cursor: pointer;
  }
}
.clr {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
  width: 20%;
  margin: 0 auto;
  font-size: 24px;
  color: #777777;
  &::after {
    content: '';
    display: block;
    width: 24px;
    height: 24px;
    background: url('../../assets/images/ic_reset.png') no-repeat;
    background-size: cover;
  }
}
.stage_msg .btn_wrap {
  margin-top: 0;
}
.stage_msg .cell {
  height: 80px;
}
.stage_msg .btn_wrap div {
  width: auto;
}
.box_btn {
  padding: 0px 45px;
  cursor: pointer;
}
.box_btn .an_t {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 21px;
  font-weight: 400;
  &::before {
    content: '+';
    width: 100%;
    height: 100%;
    line-height: normal;
    font-size: 28px;
  }
}

//modal
.button_wrap {
  display: flex;
  gap: 10px;
}
.ly_inner .box_btn {
  width: 100%;
  height: 56px;
  background: #008df3;
  border-radius: 12px;
  border: none;
  margin-top: 13px;
  font-size: 17px;
  color: #fff;
}
.warningText {
  margin: 10px 0;
  text-align: center;
}
</style>
